import { EventViewData } from 'components/eventView/pages/eventData';

export const NlsDays2025Event: EventViewData = {
    eventId: 'nlsdays2025',
    mapId: '2b83476b-67f4-4079-91a7-21980e811c64',
    guideId: 'afb854de-107c-4749-be0b-4f1c05e50ec2',
    programSettings: {
        showAddToCalendar: true,
        programTitle: 'Agenda',
        timezone: 'Europe/Stockholm',
        searchable: true,
        speakersListId: '1525b4a4-1a7a-45f5-bc57-44f3404c9369',
        embedItemBackgroundColor: '#dcdcdc'
    },
    listViewSettings: {
        'c093cbe4-8ac2-4a1a-b589-bbab195e5adb': {
            viewType: 'sections'
        }
    },
    filterSettings: {
        'aeba4f27-def0-4465-a24b-bff94695259c': {
            type: 'simple',
            optionIds: [
                'e19411d6-7118-401c-9cf2-a82de8c63e84',
                '8d555115-fdde-46a2-adc2-7873b57992e9',
                '52ecb248-510f-4783-9c09-c8d16f60ff2c',
                'bff86d84-55ae-45ca-be32-44d41eff7c96',
                '02607e8d-7a4f-4734-8328-beee92c175fb',
                '3c727b8a-fe1b-4b5c-a2dc-1eac7b2c55a7',
                'd91dea23-496c-4553-aa44-4d6cdd5ccb12',
                'fabe763a-49db-4555-8e9d-ce35b95680c6',
                '9b1a4bfe-de8f-48f7-9c56-da591530c10f',
                '6b1c0614-5c29-4257-9768-1da470a541ff',
                '9e3286d5-49be-4537-8eae-f1b99de6c65e'
            ]
        },
        'c093cbe4-8ac2-4a1a-b589-bbab195e5adb': {
            type: 'simple',
            optionIds: [
                '2999af61-0b3f-4d52-9610-6acfe13d6415',
                '5a4657e9-fcd2-479a-9cb7-eb878e68cae5',
                'd8ff99cc-530e-43db-98fe-b569aa59ccfe',
                '95fe3c28-fe72-4e39-a52a-7b1eedb2a9fe',
                'd73cb19e-e3ad-4ead-bf96-29571b79b679',
                '9d09cf34-5f47-47f1-ab6a-fb85a342cae5',
                '6c10ea54-9524-4e86-8631-2adffac8d4e4',
                '6699a0c5-c622-4764-b5f6-97f5498b186b',
                '7e592d98-c691-4e07-9c22-7576ee42dc24',
                '9053db28-6e39-46df-beb0-8c414da83baf',
                '264140a6-f3fa-4eea-973d-38ae17d881e3',
                'a422b8f2-6806-4c7a-9168-11fd86d48897',
                '7a556b8f-54f4-4d4b-9937-f8234c93239d',
                '33c19192-ec27-4845-9c64-6d3df56b5107',
                'a16f0389-0d5a-42d1-9130-cb578d13844e',
                'f47ba5fe-6803-4169-8c1e-74bdfcf5dc1c',
                '28543281-198a-46b6-824c-1f3934f76227',
                '5deb509b-4635-447d-bf12-66e94dd7a6ca',
                'd9b80eb7-7b0c-4a28-8f51-99fa604598eb',
                '109cb774-0618-4b31-930d-cc582fab23ce',
                '353f6e8f-2627-41a9-bb77-147eb2bf121d',
                '726a8278-a0ab-4e4b-837b-9eccc3128e87',
                '0d5dd478-64bb-4784-92ac-3047de404a5b',
                'f4df7877-ac9a-4cb5-ba69-0b490e95b789',
                'b6a558c2-c262-4179-88f8-c7bff10041eb',
                'c2bde951-f716-42c8-b847-c67be4bad8b2',
                'a574f42f-4ae7-40d1-9b64-93bc1615b9ab',
                '6c024d44-d009-4c66-9a0e-218219f490fa'
            ]
        }
    },
    mapSettings: {
        standZoom: 0.7
    },
    eventInfo: {
        order: {
            mobile: [
                'home',
                'program',
                'aeba4f27-def0-4465-a24b-bff94695259c',
                'map',
                'information'
            ],
            primes: ['program'],
            normal: [
                'c093cbe4-8ac2-4a1a-b589-bbab195e5adb',
                'aeba4f27-def0-4465-a24b-bff94695259c',
                '1525b4a4-1a7a-45f5-bc57-44f3404c9369',
                '...',
                'information'
            ],
            wide: [
                'home',
                'program',
                'c093cbe4-8ac2-4a1a-b589-bbab195e5adb',
                'aeba4f27-def0-4465-a24b-bff94695259c',
                '1525b4a4-1a7a-45f5-bc57-44f3404c9369',
                '...',
                'information',
                'map'
            ]
        }
    }
};
